<template>
    <v-tab-item class="fill-height">
        <texting-form v-bind="props__texting" v-on="{ posted }" />
    </v-tab-item>
</template>

<script>
import { initMeeting } from "@/assets/variables";
import TextingForm from "@/components/dashboard/company/texting/texting-form.vue";

export default {
    components: {
        TextingForm,
    },
    props: {
        value: { type: Object, default: initMeeting }, // meeting
    },
    computed: {
        props__texting() {
            const { _id: _meeting, _recruitment, recruitment, applications } = this.value;
            const initialForm = {
                _meeting,
                _recruitment,
            };
            return {
                message: this.value?._id ? `아래 링크를 클릭하여 미팅일정을 선택해주세요.\n${window.location.origin}/meetings/${this.value?._id}`: null,

                meeting: this.value,
                recruitment,
                initialForm,
                applications,
            };
        },
    },
    methods: {
        posted() {
            alert("성공적으로 문자가 발송되었습니다.");
            this.$emit("exit");
        },
    },
};
</script>
